import {
    PAYMENT_REQUEST_STATE_UNPROCESSED,
    PAYMENT_REQUEST_STATES_VALID
} from '../../../../constants/payment';

import { formatAmountCurrency } from '../../../../utils';

const getState = state => state.account.paymentrequest.ongoing;

export const isFetching = state => getState(state).fetching;

export const getOnGoingPaymentRequests = state => getState(state).requests;

export const isCurrentOnGoingPaymentRequests = state => {
    if (getOnGoingPaymentRequests(state) && getOnGoingPaymentRequests(state).length > 0) {
        return (
            getOnGoingPaymentRequests(state).filter(
                r => PAYMENT_REQUEST_STATE_UNPROCESSED === r.state
            ).length > 0
        );
    }
    return false;
};

export const getOnGoingPaidAmount = state => {
    if (getOnGoingPaymentRequests(state) && getOnGoingPaymentRequests(state).length > 0) {
        const requests = getOnGoingPaymentRequests(state);
        const total = requests
            .filter(r => PAYMENT_REQUEST_STATE_UNPROCESSED === r.state)
            .reduce((total, request) => (total = total + request.paidAmount), 0);
        return total;
    }
    return null;
};

export const getOnGoingPaidAmountFormatted = state => {
    if (getOnGoingPaidAmount(state) && getOnGoingPaidAmount(state) > 0) {
        return formatAmountCurrency(getOnGoingPaidAmount(state));
    }
    return formatAmountCurrency(0);
};

export const getValidatedPaidAmount = state => {
    if (getOnGoingPaymentRequests(state) && getOnGoingPaymentRequests(state).length > 0) {
        const requests = getOnGoingPaymentRequests(state);
        const total = requests
            .filter(r => PAYMENT_REQUEST_STATES_VALID.includes(r.state))
            .reduce((total, request) => (total = total + request.paidAmount), 0);
        return total;
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/ongoing/selector.js